import { ErrorSection } from '@components/ProductList/components/ErrorSection';
import { ProductMarketRestrictions, UnavailableProduct } from '@types';
import { useTranslation } from 'react-i18next';

interface MarketRestrictionErrorProps {
  products: UnavailableProduct[]
}

export const MarketRestrictionError = ({ products }: MarketRestrictionErrorProps) => {
  const { t } = useTranslation();

  const isShippingReason = products.some((product) => product.reason.code.includes(
    ProductMarketRestrictions.SHIPPING_RESTRICTED_COUNTRIES,
  ));

  const isBillingReason = products.some((product) => product.reason.code.includes(
    ProductMarketRestrictions.BILLING_RESTRICTED_COUNTRIES,
  ));

  return (
    <>
      {isBillingReason && (
      <ErrorSection title={t('cart.productList.billingErrorRestrictedCountry')} />
      )}

      {isShippingReason && (
      <ErrorSection title={t('cart.productList.shippingErrorRestrictedCountry')} />
      )}
    </>
  );
};
